import Tab from "@mui/material/Tab";
import MuiTabs from "@mui/material/Tabs";
import { FIGMA_COLORS } from "components-redesign/styles";
import React from "react";

export interface TabItem {
  label: string;
  value: number;
}

interface TabsProps {
  tabs: TabItem[];
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  value,
  onChange,
  className,
}) => {
  return (
    <MuiTabs
      value={value}
      onChange={onChange}
      className={className}
      sx={{
        "& .MuiTab-root": {
          textTransform: "none !important",
          position: "relative",
          "&.Mui-selected": {
            color: FIGMA_COLORS.surfaceTintLight,
          },
          "&.Mui-selected::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "60%",
            height: "3px",
            backgroundColor: FIGMA_COLORS.surfaceTintLight,
            borderRadius: "100px 100px 0 0",
          },
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}>
      {tabs.map((tab) => (
        <Tab key={tab.value} label={tab.label} />
      ))}
    </MuiTabs>
  );
};